<style scoped>
</style>
<template>
	<div>
		<Table :columns="columns1" :data="Connectors" size="small"></Table>
		<Modal v-model="modalView" :title="modal.Title" width="60%">
			<!--设备安装和设备修改-->
			<Form label-position="right" v-if="modal.type=='add'||modal.type=='update'" ref="FormItem" :model="FormItem"
				:label-width="90">
				<Row>
					<Col span=8>
					<FormItem label="价格id" prop="Id">
						<Input v-model="FormItem.Id" placeholder="价格id"></Input>
					</FormItem>
					</Col>
					<Col span=8>
					<FormItem label="价格名称" prop="Name">
						<Input v-model="FormItem.Name" placeholder="价格名称"></Input>
					</FormItem>
					</Col>
					<Col span=8>
					<FormItem label="设备类型" prop="EquipmentType">
						<Input v-model="FormItem.EquipmentType" placeholder="输入设备类型"></Input>
					</FormItem>
					</Col>
				</Row>
			</Form>
			<div v-if="modal.type!='addExcel'" slot="footer">
				<Button v-if="modal.type!='install'" type="warning" size="large" @click="modalCancel">重置</Button>
				<Button type="success" size="large" @click="modalOk">确定</Button>
			</div>
		</Modal>
	</div>
</template>
<script>
	export default {
		props: {
			row: Object
		},
		data() {
			return {
				columns1: [
					{
						title: 'ID',
						key: 'Id',
						width: 90,
					},
					{
						title: '枪编号',
						key: 'ConnectorNo',
					}, {
						title: '枪名称',
						key: 'ConnectorName',
					},
					{
						title: '枪类型',
						key: 'ConnectorType',
						render: (h, params) => {
							return h('div', params.row.ConnectorTypeDesc)
						}
					},
					// {
					// 	title: '最低输出电压(V)',
					// 	key: 'VoltageLowerLimits'
					// },
					// {
					// 	title: '最高输出电压(V)',
					// 	key: 'VoltageUpperLimits',
					// },
					// {
					// 	title: '额定功率(KW)',
					// 	key: 'Power',
					// 	// render: (h, params) => {
					// 	// 	return h('div', params.row.StationName)
					// 	// }
					// },
					// {
					// 	title: '额定电压(V)',
					// 	key: 'Voltage',
					// },
					// {
					// 	title: '额定电流(A)',
					// 	key: 'Current',
					// },
					// {
					// 	title: '辅源类型',
					// 	key: 'BmsPowerType',
					// 	render: (h, params) => {
					// 		return h('div', params.row.BmsPowerTypeDesc)
					// 	}
					// },
					// {
					// 	title: '价格id',
					// 	key: 'PriceId',
					// },
					{
						title: '充电桩编码',
						key: 'EquipmentNo',
					},
					// {
					// 	title: '车位号',
					// 	key: 'ParkNo',
					// },
					// {
					// 	title: '备注',
					// 	key: 'Remarks',
					// }
				],
				//设备信息中的枪信息列表
				Connectors: this.row.Connectors,
				//价格信息
				FormItem: {},
				//时段价格model
				modal: {
					Title: "设备添加",
					type: "add"
				},
				modalView: false
			}
		},

		methods: {
			show: function(type, ConnectorNo) {
				const _this = this;
				console.log(ConnectorNo)
				for (let i = 0; i < _this.row.Connectors.length; i++) {
					if (ConnectorNo == _this.row.Connectors[i].ConnectorNo) {
						_this.FormItem = _this.row.Connectors[i].PriceInfo
					}
				}
				_this.modalView = true
			},
			modalCancel: function(actionType) {
				this.modalView = false
			},
			modalOk: function(actionType) {
				this.modalView = false
			},
		}
	};
</script>
